import React from 'react';
import SpiderTxt from '../../../../common/src/packages/navigation/icons/spidertxt';
import { Tooltip } from 'antd';

interface FlyingSpiderTxtIconProps {
  userDisplayName?: string;
  enabled: boolean;
}

const HEIGHT = 25;
const WIDTH = 19;
const VIEWBOX = '0 0 25 25';
const SPIDERTXTBLUE = '#40A9FF';
const SPIDERTXTGRAY = '#BFBFBF';

export const FlyingSpiderTxtIcon: React.FC<FlyingSpiderTxtIconProps> = ({
  userDisplayName,
  enabled
}) => {
  if (enabled) {
    return (
      <Tooltip placement="right" title={userDisplayName} trigger="hover">
        <div style={{ display: 'inline-block' }}>
          <SpiderTxt
            height={HEIGHT}
            width={WIDTH}
            fill={'white'}
            stroke={SPIDERTXTBLUE}
            viewBox={VIEWBOX}
          />
        </div>
      </Tooltip>
    );
  }

  return (
    <SpiderTxt
      height={HEIGHT}
      width={WIDTH}
      fill={'white'}
      stroke={SPIDERTXTGRAY}
      viewBox={VIEWBOX}
    />
  );
};
